import React from "react";
import styled from "styled-components";
import Shapes from "./Shapes";
// Default icons (used only if no items are passed)



const defaultItems = [
{}
];



const Projects = ({
  items = defaultItems,
  heading = "🏆 Highlight Projects",
  showShapes = true,
  showArrows = true,
  autoScroll = true,
  speed = 0.3, // pixels per frame for auto-scroll
  iconSize = 90,
  onCardClick, // optional: (item) => void
}) => {
  const scrollRef = React.useRef(null);
  const rafRef = React.useRef(null);

  // Continuous smooth scroll (infinite loop)
  React.useEffect(() => {
    const el = scrollRef.current;
    if (!el || !autoScroll) return;

    const step = () => {
      // duplicate list visually for a seamless loop
      const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
      if (atEnd) el.scrollLeft = 0;
      else el.scrollLeft += speed;
      rafRef.current = requestAnimationFrame(step);
    };
    rafRef.current = requestAnimationFrame(step);
    return () => rafRef.current && cancelAnimationFrame(rafRef.current);
  }, [autoScroll, speed]);


  // If autoScroll is on, duplicate items for seamless loop; otherwise render once
  const renderItems = autoScroll ? [...items, ...items] : items;

  return (
    <ProjectsStyled id="projects">
      {showShapes && <Shapes />}
      <div className="container">
        <header className="header">
          <h2 className="title">{heading}</h2>
        </header>

        {showArrows && (
          <>

          </>
        )}

        <div className="scroll" ref={scrollRef}>
          <div className="chain" role="list">
            {renderItems.map((p, i) => (
              <article key={`${p.title}-${i}`} className="card" role="listitem" onClick={onCardClick ? () => onCardClick(p) : undefined}>
                <div className="icon">
                  <img src={p.icon} alt="" height={iconSize} width={iconSize} />
                </div>
                <h3 className="card-title">{p.title}</h3>
                <p className="card-blurb">{p.blurb}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </ProjectsStyled>
  );
};


const ProjectsStyled = styled.section`
  position: relative;
  background: transparent;
  color: #0a2a43;
  padding: 60px 0;
  overflow: hidden;

  .container { width: min(1200px, 92%); margin: 0 auto; }
  .header { text-align: center; margin-bottom: 28px; }
  .title { font-size: clamp(22px, 4vw, 36px); font-weight: 800; color: #0a5fd8; }

  .scroll { overflow-x: hidden; white-space: nowrap; }
  .chain { display: inline-flex; gap: 18px; }

  .card {
    background: #fff;
    border-radius: 20px;
    padding: 24px 28px;
    min-width: 320px;
    box-shadow: 0 8px 30px rgba(0,0,0,0.08);
    transition: all 0.4s ease;
    border: 1px solid rgba(10,95,216,0.15);
    text-align: center;
    cursor: default;
  }
  .card:hover { transform: translateY(-6px) scale(1.05); box-shadow: 0 16px 36px rgba(10,95,216,0.25); border-color: rgba(10,95,216,0.4); }

  .icon img { border-radius: 16px; box-shadow: 0 8px 22px rgba(0,0,0,0.15); margin-bottom: 10px; }
  .card-title { font-size: 18px; font-weight: 800; color: #0a2a43; margin: 4px 0; }
  .card-blurb { font-size: 15px; color: #244e7a; opacity: 0.9; }

  .arrow {
    position: absolute; top: 50%; transform: translateY(-50%);
    width: 54px; height: 54px; border-radius: 50%; border: none;
    background: #0a5fd8; color: #fff; box-shadow: 0 10px 26px rgba(10,95,216,.35);
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; transition: transform 0.2s ease, background 0.3s ease;
    z-index: 2;
  }
  .arrow:hover { transform: translateY(-50%) scale(1.1); background: #1171ef; }
  .arrow.left { left: 0; }
  .arrow.right { right: 0; }

  @media (max-width: 768px) {
    .arrow { display: none; }
    .card { min-width: 260px; }
  }
`;

export default Projects;
